export class ReportDialogueComponent {
    componentName: string;
    index: number;
    isSelected = true;
    calcRef: number;
}
